/**
 * envGuard.js — STAGING-1 item 10.
 * Build de staging NUNCA pode apontar para a API de produção.
 * Importado no bootstrap (index.js). Em staging + host produtivo → erro fatal.
 */
const PROD_API_HOSTS = [
  'api-arenastats-d5bnakdcdbb8b5gw.brazilsouth-01.azurewebsites.net',
  'api.arenastats.com.br',
];

export function assertEnvIsolation() {
  const env = process.env.REACT_APP_ENV || 'production';
  const apiBase = process.env.REACT_APP_API_BASE_URL || '';
  if (env === 'staging' && PROD_API_HOSTS.some((h) => apiBase.includes(h))) {
    const msg =
      '[envGuard] BLOQUEADO: build staging apontando para API de PRODUÇÃO. ' +
      'Corrija REACT_APP_API_BASE_URL.';
    // eslint-disable-next-line no-console
    console.error(msg);
    throw new Error(msg);
  }
}

export default assertEnvIsolation;
